import request from '@host-panel/request';

import { getJWTToken } from '../../scripts/services/app-state';

import { FetchMonetizationDataRequestPayload, FetchMonetizationDataResponse } from './monetizationTypes';

export function fetchMonetizationDataRequest(
  payload: FetchMonetizationDataRequestPayload
): Promise<FetchMonetizationDataResponse> {
  const { spotId, source, device, fromDay, toDay } = payload;

  const sourceParam = source === 'all' ? {} : { source };
  const deviceParam = device === 'all' ? {} : { device };
  const accessToken = getJWTToken() || window.localStorage?.getItem('SPOTIM_ACCESS_TOKEN');

  return request('/host-panel/monetization/data', {
    credentials: 'omit',
    headers: {
      'x-access-token': accessToken
    },
    data: {
      from: fromDay,
      to: toDay,
      spot_id: spotId,
      ...sourceParam,
      ...deviceParam
    }
  });
}
